import { z } from "zod";

/**
 * An amount of money in euro cents: always an integer, never a float. €4,99 is `499`. Every
 * price, total, VAT amount and refund in the contract uses this.
 */
export const Cents = z.number().int();
export type Cents = z.infer<typeof Cents>;
